import React, { useEffect } from 'react';
import styles from './GalleryImage.module.scss';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import clsx from 'clsx';
import PrevImage from '../PrevImage/PrevImage';
import { Box } from '@mui/material';

const GalleryImage = ({ form, name, label }) => {
  const params = {
    spaceBetween: 16,
    slidesPerView: 'auto',
    slideClass: 'swiper-slide-category',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };
  const value = form.watch(name);
  return (
    <div className={clsx(styles.wrap)}>
      {label && <Box sx={{ mb: '8px', fontWeight: '600' }}>{label}</Box>}
      <Swiper {...params}>
        {value?.map((img, index) => (
          <div>
            <PrevImage form={form} name={`${name}[${index}]`} />
          </div>
        ))}
      </Swiper>
    </div>
  );
};

export default GalleryImage;
